var _ellipse, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCircleTick(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.5485,
    cy: 14.9217,
    rx: 14.5487,
    ry: 14.9217,
    transform: "rotate(-180 14.5485 14.9217)",
    fill: "#97D318"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2697 19.006L7.79967 15.536C7.40967 15.146 6.77967 15.146 6.38967 15.536C5.99967 15.926 5.99967 16.556 6.38967 16.946L10.5697 21.126C10.9597 21.516 11.5897 21.516 11.9797 21.126L22.5597 10.546C22.9497 10.156 22.9497 9.52598 22.5597 9.13598C22.1697 8.74598 21.5397 8.74598 21.1497 9.13598L11.2697 19.006Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCircleTick);
export default __webpack_public_path__ + "static/media/icon-circleTick.fa99148bce7d922310ad5c729a0a2581.svg";
export { ForwardRef as ReactComponent };